module.exports = __webpack_public_path__ + "img/scene2-1.22600b14.png";